module.exports = __webpack_public_path__ + "static/img/dress_casual_pending original.4759d61f.jpg";